/**
 * @desc 查看新品下单详情
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<defs.basics.PlmSkuNewOrderDetailResponseDto>;
export function request(npono: string, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/product/order/${npono}`, {
      method: "GET",

      ...options,
    }),
  );
}
